export default function Services() {
  const services = [
    {
      icon: 'ri-restaurant-line',
      title: 'Kitchen Remodeling',
      description: 'Custom cabinetry, modern appliances, and innovative layouts that make your kitchen the heart of your home.',
      image: 'https://public.readdy.ai/ai/img_res/f9617fbf00f1c8f60bdee15c3fb6e735.jpg',
      bgColor: 'bg-gray-900'
    },
    {
      icon: 'ri-drop-line',
      title: 'Bathroom Renovation',
      description: 'Spa-like retreats with premium fixtures, elegant tile work, and thoughtful design for ultimate relaxation.',
      image: 'https://readdy.ai/api/search-image?query=elegant%20modern%20bathroom%20with%20freestanding%20tub%2C%20walk-in%20shower%2C%20marble%20tiles%2C%20double%20vanity%2C%20ambient%20lighting%2C%20luxury%20spa%20atmosphere%2C%20clean%20contemporary%20design%2C%20professional%20interior%20photography&width=600&height=400&seq=service-bathroom&orientation=landscape',
      bgColor: 'bg-white',
      popular: true
    },
    {
      icon: 'ri-home-4-line',
      title: 'Whole Home Transformation',
      description: 'Complete renovations that reimagine your entire living space with cohesive design and superior craftsmanship.',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20modern%20home%20exterior%20with%20contemporary%20architecture%2C%20large%20windows%2C%20landscaped%20front%20yard%2C%20clean%20lines%2C%20neutral%20colors%2C%20professional%20real%20estate%20photography%2C%20upscale%20residential%20design&width=600&height=400&seq=service-whole-home&orientation=landscape',
      bgColor: 'bg-stone-50'
    }
  ];

  return (
    <section id="services" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16">
          <p className="text-sm font-semibold text-gray-600 tracking-wider uppercase mb-3">OUR SERVICES</p>
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Comprehensive Remodeling Solutions
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {services.map((service, index) => (
            <div
              key={index}
              className={`${service.bgColor} rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer`}
            >
              {service.image && (
                <div className="relative h-64 w-full">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top"
                  />
                  {service.popular && (
                    <div className="absolute top-4 left-4 px-4 py-1.5 bg-black/70 backdrop-blur-sm rounded-full">
                      <span className="text-white text-xs font-semibold">POPULAR</span>
                    </div>
                  )}
                </div>
              )}
              <div className="p-8">
                <div className={`w-12 h-12 flex items-center justify-center rounded-full ${service.bgColor === 'bg-gray-900' ? 'bg-white' : 'bg-gray-900'} mb-4`}>
                  <i className={`${service.icon} text-2xl ${service.bgColor === 'bg-gray-900' ? 'text-gray-900' : 'text-white'}`}></i>
                </div>
                <h3 className={`text-2xl font-semibold mb-3 ${service.bgColor === 'bg-gray-900' ? 'text-white' : 'text-gray-900'}`}>
                  {service.title}
                </h3>
                <p className={`text-sm leading-relaxed ${service.bgColor === 'bg-gray-900' ? 'text-gray-300' : 'text-gray-600'}`}>
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button className="px-8 py-3 bg-gray-900 text-white text-sm font-semibold rounded-full hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer">
            View All Services
          </button>
          <button className="px-8 py-3 bg-transparent text-gray-900 text-sm font-semibold rounded-full border-2 border-gray-900 hover:bg-gray-900 hover:text-white transition-all whitespace-nowrap cursor-pointer">
            Schedule Consultation
          </button>
        </div>
      </div>
    </section>
  );
}
